import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormGroup , FormControl , ReactiveFormsModule , FormsModule } from '@angular/forms';
import { CommonModule }  from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { SignInFormComponent } from './components/users/sign-in-form/sign-in-form.component';
import { RegisterFormComponent } from './components/users/register-form/register-form.component';
import { RequestResetComponent } from './components/users/request-reset/request-reset.component';
import { ResponseResetComponent } from './components/users/response-reset/response-reset.component';

import { DealsComponent } from './components/deals/deals.component';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { ActiveDealsComponent } from './components/deals/active-deals/active-deals.component';
import { ExpiredDealsComponent } from './components/deals/expired-deals/expired-deals.component';
import { PublicDealsComponent } from './components/deals/public-deals/public-deals.component';
import { ProposeDealsComponent } from './components/deals/propose-deals/propose-deals.component';

import { ProductsComponent } from './components/products/products.component';
import { ProductsActiveListComponent } from './components/products/products-active-list/products-active-list.component';
import { GroupsComponent } from './components/groups/groups.component';
import { GroupsActiveListComponent } from './components/groups/groups-active-list/groups-active-list.component';
import { InboundComponent } from './components/inbound/inbound.component';
import { ToConfirmListComponent } from './components/inbound/to-confirm-list/to-confirm-list.component';
import { ReportedListComponent } from './components/inbound/reported-list/reported-list.component';
import { PaymentListComponent } from './components/inbound/payment-list/payment-list.component';
import { HistoryListComponent } from './components/inbound/history-list/history-list.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LinkifyPipe } from './custom-pipes/linkify.pipe';
import { UserGroupsComponent } from './components/groups/user-groups/user-groups.component';
import { UserJoinComponent } from './components/groups/user-join/user-join.component';
import { ActivateComponent } from './components/users/activate/activate.component';
import { StorageComponent } from './components/storage/storage.component';
import { BillComponent } from './components/bill/bill.component';
import { BillPayComponent } from './components/billpay/billpay.component';
import { KeysPipe } from './custom-pipes/keys.pipe';
import { UsersComponent } from './components/users/users.component';
import { WarehousePolicyComponent } from './components/policy/warehouse-policy/warehouse-policy.component';

//import { RequestResetComponent } from './components/users/request-reset/request-reset.component';
//import { ResponseResetComponent } from './components/users/users.component';

//分页
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagerModule } from '@progress/kendo-angular-pager';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';

import { NotificationModule } from '@progress/kendo-angular-notification';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

import { LayoutModule } from "@progress/kendo-angular-layout";
import { IconsModule } from "@progress/kendo-angular-icons";
import { LabelModule } from "@progress/kendo-angular-label";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";


//消息提示
import { AlertModule } from './_alert';
import { MultiAlertsComponent } from './multi-alerts';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; 
//import { DeleteConfirmationDailogComponent } from './delete-confirmation-dailog/delete-confirmation-dailog.component';  


//import { MaterialModule } from '@angular/material.module';
//添加fontAwesomeModule字体
//import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';



@NgModule({
  declarations: [
    AppComponent,        
    TopBarComponent,
    SignInFormComponent,
    RegisterFormComponent,
    RequestResetComponent,
    ResponseResetComponent,
    ProposeDealsComponent,
    ProductsComponent,
    ProductsActiveListComponent,
    GroupsComponent,
    GroupsActiveListComponent,
    InboundComponent,
    ToConfirmListComponent,
    ReportedListComponent,
    PaymentListComponent,
    HistoryListComponent,
    DashboardComponent,
    LinkifyPipe,
    UserGroupsComponent,
    UserJoinComponent,
    WarehousePolicyComponent,
    ActivateComponent,
    StorageComponent,
    BillComponent,
    BillPayComponent,
    KeysPipe,
    DealsComponent,
    ActiveDealsComponent,
    ExpiredDealsComponent,
    PublicDealsComponent,
    ProposeDealsComponent,
    UsersComponent,
    MultiAlertsComponent
  ],
  imports: [BrowserModule, FormsModule ,CommonModule ,ReactiveFormsModule, AppRoutingModule, HttpClientModule ,BrowserAnimationsModule,PagerModule,InputsModule,LabelModule,NotificationModule,ButtonsModule, GridModule, ExcelModule,
LayoutModule,IconsModule,AlertModule,DateInputsModule, NgbModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
